module.exports = __webpack_public_path__ + "static/fonts/NanumGothic_seR.40413e5.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/NanumGothic_seR.woff
// module id = 0r5u
// module chunks = 241